import React from 'react';
import { BLOG as posts } from '../data/profile';

export default function Blog() {
  return (
    <section id="blog" className="section">
      <div className="container">
        <h2>Blog</h2>
        <p className="muted" style={{ marginBottom: 18 }}>Notes on building AI products, sandboxes, and UX.</p>
        <div className="grid">
          {posts.map(p => (
            <article key={p.title} className="card">
              <h3 style={{ marginBottom: 6 }}>{p.title}</h3>
              <div className="muted" style={{ fontSize: 12, marginBottom: 10 }}>{new Date(p.date).toDateString()}</div>
              <p style={{ marginBottom: 16 }}>{p.excerpt}</p>
              <div style={{ marginTop: 'auto', paddingTop: 16 }}>
                <a className="btn" href={p.link} target="_blank" rel="noreferrer" aria-label={`Read ${p.title}`}>Read</a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
